<p-dialog id="searchprodgroup"
          [header]="header"
          [appTabTitle]="header"
          [(visible)]="display"
          [modal]="modal"
          [resizable]="false"
          (onShow)="onShowDialog()"
          (onHide)="onHideDialog()"
          class="prod-group-dlg"
          [style]="{'width': '40vw'}"

          >

  <ng-template pTemplate="content">
    <div>
      <app-prod-group-tree [groupId]="groupId" (selectedGroup)="onSelectedGroup($event)" ></app-prod-group-tree>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button label="ОК!" icon="pi pi-check" (click)="onConfirm('ok')" [disabled]="!canClose"></p-button>
    <p-button label="Отмена" icon="pi pi-times" (click)="display=false"></p-button>
  </ng-template>
</p-dialog>
